import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import {gaEvent, gaLocationAndContentData} from "../../utils/index";

//input files --->
import CareersRegisterInputEmail from "./CareersRegisterInputEmail";
import CareersRegisterInputMobile from "./CareersRegisterInputMobile";
import CareersRegisterInputName from "./CareersRegisterInputName";

//Select files-->
import CareersRegisterSingleSelect from "./CareersRegisterSingleSelect";
import CareersRegisterMultiSelect from "./CareersRegisterMultiSelect";
import CareersRegisterRadioSingleSelect from "./CareersRegisterRadioSingleSelect";

//checkbox and radio
import CareersRegisterRadio from "./CareersRegisterRadio";
import CareersRegisterCheckboxes from "./CareersRegisterCheckboxes";
import Cookies from "universal-cookie";
import CareersRegisterInputLocation from "./CareersRegisterLocation";
import CareersRegisterInputOtp from "./CareersRegisterInputOtp";

const CareersRegisterControl = (props) => {
  const [isMobileFocused, setIsMobileFocused] = useState(false);
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [selectedAreaOfInterestValues, setSelectedAreaOfInterestValues] = useState([]);
  const [editMobile, setEditMobile] = useState(false);

  const { userLoginSignupOtp, userLoginSignupOtpError } = useSelector((state) => state.usersCommonData)
  const urlCheckData = {
    updateProfile: window.location.href.includes("/user/update-profile"),
    completeProfile: window.location.href.includes("/user/complete-profile"),
    isProfileCheck: window.location.href.includes("/user/complete-profile") || window.location.href.includes("/user/update-profile"),
  };

  const cookies = new Cookies();

  const {
    control,
    name,
    values,
    setFieldValue,
    errors,
    touched,
    fieldSelectType,
    placeholder,
    maxLimit,
    handleBlur,
    dropdownData,
    domain,
    searchBar,
    updateTouchedFields,
    setTouched
  } = props;

  // Function to handle OTP resend timer
  const resendOtpTimer = () => {
    props.setRemainingSeconds(30);
    const currentTime = new Date();
    const currentSeconds = currentTime.getSeconds();
    localStorage.setItem("remainingSeconds", currentSeconds);
    };

  useEffect(() => {
    if (urlCheckData.isProfileCheck && userLoginSignupOtpError) {
        setEditMobile(true);
        props.setFormCurrentState((prev) => ({
          ...prev, isMobileEditing: true
        }))
    }
    if(urlCheckData.isProfileCheck && userLoginSignupOtpError?.block_user_case === "try_again"){
          const totalRemainingSecs = userLoginSignupOtpError?.available_in?.split(" ")?.[0];
          props.setRemainingSeconds(totalRemainingSecs);
          const currentTime = new Date();
          const currentSeconds = currentTime.getSeconds();
          localStorage.setItem("remainingSeconds", currentSeconds);
    }
  }, [userLoginSignupOtpError])

  useEffect(() => { //to clear edit mobile on successful otp response
    if (urlCheckData.isProfileCheck && (userLoginSignupOtp?.otp_on == "mobile" || userLoginSignupOtpError?.block_user_case === "try_again")) {
      if(urlCheckData.updateProfile){
        gaEvent("mobilesendupdateprofile", "login_signup", `${gaLocationAndContentData}`, "");
      }else if(urlCheckData.completeProfile){
        gaEvent("mobilesendcompleteprofile", "login_signup", `${gaLocationAndContentData}`, "");
      }
      setEditMobile(false);
      props.setFormCurrentState((prev) => ({
        ...prev, isMobileEditing: false
      }))
    }
    }, [userLoginSignupOtp, userLoginSignupOtpError])


  switch (control) {
    case "text":
      if (name == "email") {
        return (
          <CareersRegisterInputEmail
            setFieldValue={setFieldValue}
            values={values}
            name={name}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            setIsEmailFocused={setIsEmailFocused}
            updateTouchedFields={updateTouchedFields}
            setSyncSignupValues={props.setSyncSignupValues}
          />
        );
      } else if (name == "mobile") {
        return (
          <CareersRegisterInputMobile
            setFieldValue={setFieldValue}
            name={name}
            values={values}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            geolocationData={props.geolocationData}
            setIsMobileFocused={setIsMobileFocused}
            updateTouchedFields={updateTouchedFields}
            setSyncSignupValues={props.setSyncSignupValues}
            handleChange={props.handleChange}
            otpGetClicked={() => props.SendOtpOnMobile()}
            otpVerifyClicked={props.otpVerifyClicked}
            setEditMobile={setEditMobile}
            editMobile={editMobile}
            postSignupData={props.postSignupData}
            setFormCurrentState={props.setFormCurrentState}
            formCurrentState={props.formCurrentState}
            resetTimer={resendOtpTimer}
            setFormikValues={props.setFormikValues}
            setReinitialize={props.setReinitialize}
            setTouched={setTouched}
            signupDataPost={(type, level, name, mobile, location)=> props.signupDataPost(type, level, name, mobile, location)}
          />
        );
      } else if (name == "studentname" || name == "name") {
        return (
          <CareersRegisterInputName
            setFieldValue={setFieldValue}
            name={name}
            values={values}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            updateTouchedFields={updateTouchedFields}
            setSyncSignupValues={props.setSyncSignupValues}
            signupDataPost={(type, level, name, mobile, location)=> props.signupDataPost(type, level, name, mobile, location)}
          />
        );
      } else if (name == "location") {
        return (
          <CareersRegisterInputLocation
            setFieldValue={setFieldValue}
            values={values}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            domain={domain}
            name={name}
            updateTouchedFields={updateTouchedFields}
            setSyncSignupValues={props.setSyncSignupValues}
            setFormikValues={props.setFormikValues}
            signupDataPost={(type, level, name, mobile, location)=> props.signupDataPost(type, level, name, mobile, location)}
          />
        );
      } else if (name == "otp") {
        return (
          <CareersRegisterInputOtp
            setFieldValue={setFieldValue}
            values={values}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            domain={domain}
            name={name}
            updateTouchedFields={updateTouchedFields}
            setRemainingSeconds={props.setRemainingSeconds}
            remainingSeconds={props.remainingSeconds}
            setFormikValues={props.setFormikValues}
            setReinitialize={props.setReinitialize}
            otpGetClicked={() => props.SendOtpOnMobile()}
            otpSubmitMobile={() => props.handleOtpVerify()}
            setFormCurrentState={props.setFormCurrentState}
            formCurrentState={props.formCurrentState}
            resetTimer={resendOtpTimer}
          />
        )
      }
    case "dropdown-singleSelect-radio":
      return (
        <CareersRegisterRadioSingleSelect
          name={name}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          dropdownData={dropdownData}
          domain={domain}
          handleOnFocus={(event, name, item) => props.handleOnFocus(event, name, item)}
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
          setTouched={props.setTouched}
          isUpdateProfile={props.isUpdateProfile}
          setFormikValues={props.setFormikValues}
          setReinitialize={props.setReinitialize}
          setSelectedAreaOfInterestValues={setSelectedAreaOfInterestValues}
          postUpdateProfileOnChange={(option, val, interest, certificateId, isLevel) => props.postUpdateProfileOnChange(option, val, interest, certificateId, isLevel)}
          areaOfInterestApiCall ={(level, interest, eduInterest, cerInterest) => props.areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
          apiCallBasedOnStudyingIn={(name, option) => props.apiCallBasedOnStudyingIn(name, option)}
          setSyncSignupValues={props.setSyncSignupValues}
          signupDataPost={(type, level, name, mobile, location)=> props.signupDataPost(type, level, name, mobile, location)}
        />
      );
    case !!name && "dropdown-singleSelect":
      return (
        <CareersRegisterSingleSelect
          name={name}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          dropdownData={dropdownData}
          handleOnFocus={(event, name, item) => props.handleOnFocus(event, name, item)}
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
          isUpdateProfile={props.isUpdateProfile}
          domain={props.domain}
          setTouched={props.setTouched}
          setFormikValues={props.setFormikValues}
          setReinitialize={props.setReinitialize}
          postUpdateProfileOnChange={(option, val, interest, certificateId, isLevel) => props.postUpdateProfileOnChange(option, val, interest, certificateId, isLevel)}
          areaOfInterestApiCall ={(level, interest, eduInterest, cerInterest) => props.areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
        />
      );

    case "dropdown-multiSelect-checkbox":
      return (
        <CareersRegisterMultiSelect
          name={name}
          label={props.label}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          touched={touched}
          setTouched={setTouched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          dropdownData={dropdownData}
          handleOnFocus={(event, name, item) => props.handleOnFocus(event, name, item)}
          maxLimit={maxLimit}
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
          setFormikValues={props.setFormikValues}
          setReinitialize={props.setReinitialize}
          selectedAreaOfInterestValues={selectedAreaOfInterestValues}
          setSelectedAreaOfInterestValues={setSelectedAreaOfInterestValues}
        />
      );

    case "checkbox":
      return (
        <CareersRegisterCheckboxes
          name={name}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          fieldErrors={props.fieldErrors}
          touched={touched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          interestedInCheckbox={props.interestedInCheckbox}
          handleInterestedCheckbox={(item, id) =>
            props.handleInterestedCheckbox(item, id)
          }
          item={props.item}
          dropdownData={dropdownData}
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
          setTouched={props.setTouched}
          domain={props.domain}
          postUpdateProfileOnChange={(option, val, interest, certificateId, isLevel) => props.postUpdateProfileOnChange(option, val, interest, certificateId, isLevel)}
          setFormikValues={props.setFormikValues}
          selectedAreaOfInterestValues={selectedAreaOfInterestValues}
          setSelectedAreaOfInterestValues={setSelectedAreaOfInterestValues}
          areaOfInterestApiCall ={(level, interest, eduInterest, cerInterest) => props.areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
          apiCallBasedOnStudyingIn={(name, option) => props.apiCallBasedOnStudyingIn(name, option)}
          isUpdateProfile={props.isUpdateProfile}
        />

      );

    case "radio":
      return (
        <CareersRegisterRadio
          name={name}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          radioBtn={props.radioBtn}
          dropdownData={dropdownData}
          handleRadioChange={(item, id) =>
            props.handleRadioChange(item, id)
          }
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
        />
      );

    default:
      return null;
  }

};

export default CareersRegisterControl;
